/**
 * Утилита для получения текста статуса голосового виджета
 */

import { t } from '../translations';

/**
 * Определяет текст статуса на основе состояния соединения и речи
 * @param {Object} params - Параметры состояния
 * @param {string} params.connectionStatus - 'connecting' | 'connected' | 'disconnected'
 * @param {boolean} params.isSpeaking - Говорит ли агент
 * @param {boolean} params.isUserSpeaking - Говорит ли пользователь
 * @param {string} params.language - Код языка: 'en' | 'ru' | 'nl'
 * @returns {string} Локализованный текст статуса
 */
export const getStatusText = ({
  connectionStatus = 'connected',
  isSpeaking = false,
  isUserSpeaking = false,
  language = 'en',
}) => {
  // Issue #566: Show real connection state
  if (connectionStatus === 'connecting') {
    return t('connecting', language);
  }
  // Issue #566: Show reconnecting during auto-retry after navigation
  if (connectionStatus === 'disconnected') {
    return t('reconnecting', language);
  }
  if (isSpeaking) {
    return t('speaking', language);
  }
  if (isUserSpeaking) {
    return t('listening', language);
  }
  return t('listening', language);
};
